import Button from "@mui/material/Button";
import {
  Stack,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormGroup,
  Checkbox,
} from "@mui/material";

import { FieldInputText, FieldSelect } from "../../../../../components/Fields";

import "../../styles.css";

const CustomBox = ({
  label,
  fieldNameRight,
  valueRight,
  fieldNameLeft,
  valueLeft,
  setData,
}) => {
  function handleSetData(value, name) {
    setData((prevState) => ({
      ...prevState,
      [name]: value > 5 ? 5 : value,
    }));
  }
  return (
    <Stack
      sx={{
        background: "#EFF5F7",
        padding: "16px",
        gap: "16px",
        border: "1px solid #1E729F",
        borderRadius: "5px",
        "& div, label": {
          background: "transparent !important",
        },
        "& input": {
          background: "white !important",
        },
      }}
    >
      <Stack className="subTitleSection" component="span">
        {label}
      </Stack>
      <Stack gap="16px" display="grid" gridTemplateColumns="1fr 1fr">
        <FieldInputText
          label="Direita"
          value={valueRight}
          setValue={(value) => handleSetData(value, fieldNameRight)}
          type="number"
        />
        <FieldInputText
          label="Esquerda"
          value={valueLeft}
          setValue={(value) => handleSetData(value, fieldNameLeft)}
          type="number"
        />
      </Stack>
    </Stack>
  );
};

export default function PainelMotor({
  handleChangePanel,
  onSubmit,
  data,
  setData,
  simOuNaoOptions,
  presenteAusenteOptions,
  fasciculacoesOndeOptions,
  handleCheckedField,
  tonusMuscularOptions,
  reflexoOptions,
}) {
  function handleSetData(value, field) {
    if (field === "fasciculacoesMotor" && value === "51") {
      setData((prevState) => ({
        ...prevState,
        fasciculacoesMotor: value,
        fasciculacoesMotorOnde: [],
      }));
    } else {
      setData((prevState) => ({
        ...prevState,
        [field]: value,
      }));
    }
  }
  return (
    <form autoComplete="off" onSubmit={onSubmit}>
      <Stack component="h2" className="titleSection">
        Força muscular
      </Stack>
      <Stack component="h3" className="subTitleSection">
        Membros inferiores
      </Stack>
      <Stack className="templateGridForm">
        <CustomBox
          label="Abdução das coxas"
          fieldNameRight="abducaoCoxasDireita"
          valueRight={data.abducaoCoxasDireita}
          fieldNameLeft="abducaoCoxasEsquerda"
          valueLeft={data.abducaoCoxasEsquerda}
          setData={setData}
        />
        <CustomBox
          label="Flexão dos quadris"
          fieldNameRight="flexaoQuadrisDireita"
          valueRight={data.flexaoQuadrisDireita}
          fieldNameLeft="flexaoQuadrisEsquerda"
          valueLeft={data.flexaoQuadrisEsquerda}
          setData={setData}
        />
        <CustomBox
          label="Extensão dos joelhos"
          fieldNameRight="extensaoJoelhosDireita"
          valueRight={data.extensaoJoelhosDireita}
          fieldNameLeft="extensaoJoelhosEsquerda"
          valueLeft={data.extensaoJoelhosEsquerda}
          setData={setData}
        />
        <CustomBox
          label="Flexão dos joelhos"
          fieldNameRight="flexaoJoelhosDireita"
          valueRight={data.flexaoJoelhosDireita}
          fieldNameLeft="flexaoJoelhosEsquerda"
          valueLeft={data.flexaoJoelhosEsquerda}
          setData={setData}
        />
        <CustomBox
          label="Dorsiflexão dos joelhos"
          fieldNameRight="dorsiflexaoJoelhosDireita"
          valueRight={data.dorsiflexaoJoelhosDireita}
          fieldNameLeft="dorsiflexaoJoelhosEsquerda"
          valueLeft={data.dorsiflexaoJoelhosEsquerda}
          setData={setData}
        />
        <CustomBox
          label="Inversão dos pés"
          fieldNameRight="inversaoPesDireita"
          valueRight={data.inversaoPesDireita}
          fieldNameLeft="inversaoPesEsquerda"
          valueLeft={data.inversaoPesEsquerda}
          setData={setData}
        />
        <CustomBox
          label="Flexão plantar dos pés"
          fieldNameRight="flexaoPlanarPesDireita"
          valueRight={data.flexaoPlanarPesDireita}
          fieldNameLeft="flexaoPlanarPesEsquerda"
          valueLeft={data.flexaoPlanarPesEsquerda}
          setData={setData}
        />
      </Stack>

      <Stack component="h3" className="subTitleSection">
        Membros superiores
      </Stack>
      <Stack className="templateGridForm">
        <CustomBox
          label="Abdução das ombros"
          fieldNameRight="abducaoOmbrosDireita"
          valueRight={data.abducaoOmbrosDireita}
          fieldNameLeft="abducaoOmbrosEsquerda"
          valueLeft={data.abducaoOmbrosEsquerda}
          setData={setData}
        />
        <CustomBox
          label="Flexão dos cotovelos"
          fieldNameRight="flexaoCotovelosDireita"
          valueRight={data.flexaoCotovelosDireita}
          fieldNameLeft="flexaoCotovelosEsquerda"
          valueLeft={data.flexaoCotovelosEsquerda}
          setData={setData}
        />
        <CustomBox
          label="Extensão dos cotovelos"
          fieldNameRight="extensaoCotovelosDireita"
          valueRight={data.extensaoCotovelosDireita}
          fieldNameLeft="extensaoCotovelosEsquerda"
          valueLeft={data.extensaoCotovelosEsquerda}
          setData={setData}
        />
        <CustomBox
          label="Flexão dos punhos"
          fieldNameRight="flexaoPunhosDireita"
          valueRight={data.flexaoPunhosDireita}
          fieldNameLeft="flexaoPunhosEsquerda"
          valueLeft={data.flexaoPunhosEsquerda}
          setData={setData}
        />
        <CustomBox
          label="Extensão dos dedos"
          fieldNameRight="extensaoDedosDireita"
          valueRight={data.extensaoDedosDireita}
          fieldNameLeft="extensaoDedosEsquerda"
          valueLeft={data.extensaoDedosEsquerda}
          setData={setData}
        />
        <CustomBox
          label="Abdução dos 5 dedos"
          fieldNameRight="abducaoDedosDireita"
          valueRight={data.abducaoDedosDireita}
          fieldNameLeft="abducaoDedosEsquerda"
          valueLeft={data.abducaoDedosEsquerda}
          setData={setData}
        />
        <CustomBox
          label="Abdução do polegar"
          fieldNameRight="abducaoPolegarDireita"
          valueRight={data.abducaoPolegarDireita}
          fieldNameLeft="abducaoPolegarEsquerda"
          valueLeft={data.abducaoPolegarEsquerda}
          setData={setData}
        />
        <CustomBox
          label="Primeiro interosseo dorsal"
          fieldNameRight="primeiroInterosseoDorsalDireita"
          valueRight={data.primeiroInterosseoDorsalDireita}
          fieldNameLeft="primeiroInterosseoDorsalEsquerda"
          valueLeft={data.primeiroInterosseoDorsalEsquerda}
          setData={setData}
        />
      </Stack>

      <Stack component="h2" className="titleSection">
        Atrofia muscular
      </Stack>
      <Stack className="templateGridForm">
        <FieldSelect
          label="MID Proximal"
          value={data.MIDProximal}
          setValue={(value) => handleSetData(value, "MIDProximal")}
          items={presenteAusenteOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="MID Distal"
          value={data.MIDDistal}
          setValue={(value) => handleSetData(value, "MIDDistal")}
          items={presenteAusenteOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="MIE Proximal"
          value={data.MIEProximal}
          setValue={(value) => handleSetData(value, "MIEProximal")}
          items={presenteAusenteOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="MIE Distal"
          value={data.MIEDistal}
          setValue={(value) => handleSetData(value, "MIEDistal")}
          items={presenteAusenteOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="MSD Proximal"
          value={data.MSDProximal}
          setValue={(value) => handleSetData(value, "MSDProximal")}
          items={presenteAusenteOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="MSD Distal"
          value={data.MSDDistal}
          setValue={(value) => handleSetData(value, "MSDDistal")}
          items={presenteAusenteOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="MSE Proximal"
          value={data.MSEProximal}
          setValue={(value) => handleSetData(value, "MSEProximal")}
          items={presenteAusenteOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="MSE Distal"
          value={data.MSEDistal}
          setValue={(value) => handleSetData(value, "MSEDistal")}
          items={presenteAusenteOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
      </Stack>

      <Stack>
        <Stack component="h2" className="subTitleSection">
          Fasciculações
        </Stack>
        <RadioGroup row>
          {simOuNaoOptions.map(({ key, value }) => {
            return (
              <FormControlLabel
                value={value}
                control={<Radio />}
                checked={data.fasciculacoesMotor === value}
                label={key}
                onChange={(e) =>
                  handleSetData(e.target.value, "fasciculacoesMotor")
                }
                key={value}
              />
            );
          })}
        </RadioGroup>
        {data.fasciculacoesMotor === "50" && (
          <Stack className="templateGridForm">
            <FormGroup
              className="templateGridFormCheckbox CheckboxColor"
              sx={{
                gridTemplateColumns: "repeat(auto-fit, minmax(250px,1fr ))",
                gridColumn: "span 2",
              }}
            >
              {fasciculacoesOndeOptions.map(({ key, value }) => {
                return (
                  <FormControlLabel
                    value={value}
                    control={<Checkbox />}
                    label={key}
                    onClick={(e) =>
                      handleCheckedField(e, "fasciculacoesMotorOnde")
                    }
                    key={value}
                  />
                );
              })}
            </FormGroup>
            <Stack sx={{ gridColumn: "span 2" }}></Stack>
          </Stack>
        )}
      </Stack>

      <Stack component="h2" className="titleSection">
        Tônus muscular:
      </Stack>
      <Stack className="templateGridForm">
        <FieldSelect
          label="MSD"
          value={data.MSD}
          setValue={(value) => handleSetData(value, "MSD")}
          items={tonusMuscularOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="MSE"
          value={data.MSE}
          setValue={(value) => handleSetData(value, "MSE")}
          items={tonusMuscularOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="MID"
          value={data.MID}
          setValue={(value) => handleSetData(value, "MID")}
          items={tonusMuscularOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="MIE"
          value={data.MIE}
          setValue={(value) => handleSetData(value, "MIE")}
          items={tonusMuscularOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
      </Stack>

      <Stack component="h2" className="titleSection">
        Reflexos profundos
      </Stack>

      <Stack className="templateGridForm">
        <CustomBox
          label="Reflexo bicipital"
          fieldNameRight="reflexoBicipitalDireita"
          valueRight={data.reflexoBicipitalDireita}
          fieldNameLeft="reflexoBicipitalEsquerda"
          valueLeft={data.reflexoBicipitalEsquerda}
          setData={setData}
        />
        <CustomBox
          label="Reflexo tricipital"
          fieldNameRight="reflexoTricipitalDireita"
          valueRight={data.reflexoTricipitalDireita}
          fieldNameLeft="reflexoTricipitalEsquerda"
          valueLeft={data.reflexoTricipitalEsquerda}
          setData={setData}
        />
        <CustomBox
          label="Reflexo patelar"
          fieldNameRight="reflexoPatelarDireita"
          valueRight={data.reflexoPatelarDireita}
          fieldNameLeft="reflexoPatelarEsquerda"
          valueLeft={data.reflexoPatelarEsquerda}
          setData={setData}
        />
        <CustomBox
          label="Reflexo aquileu"
          fieldNameRight="reflexoAquileuDireita"
          valueRight={data.reflexoAquileuDireita}
          fieldNameLeft="reflexoAquileuEsquerda"
          valueLeft={data.reflexoAquileuEsquerda}
          setData={setData}
        />
      </Stack>

      <Stack component="h2" className="titleSection">
        Reflexos superficiais
      </Stack>

      <Stack className="templateGridForm">
        <Stack sx={{ gridColumn: "span 2", gap: "8px" }}>
          <Stack component="h2" className="subTitleSection" margin="0px">
            Reflexo cutâneo-plantar
          </Stack>
          <Stack display="grid" className="templateGridForm">
            <FieldSelect
              label="Direita"
              value={data.reflexoCutaneoDireita}
              setValue={(value) =>
                handleSetData(value, "reflexoCutaneoDireita")
              }
              items={reflexoOptions.map((c) => {
                return { id: c.value, label: c.key };
              })}
            />
            <FieldSelect
              label="Esquerda"
              value={data.reflexoCutaneoEsquerda}
              setValue={(value) =>
                handleSetData(value, "reflexoCutaneoEsquerda")
              }
              items={reflexoOptions.map((c) => {
                return { id: c.value, label: c.key };
              })}
            />
          </Stack>
        </Stack>
        <Stack sx={{ gridColumn: "span 2", gap: "8px" }}>
          <Stack component="h2" className="subTitleSection" margin="0px">
            Sinal de Hoffmann
          </Stack>
          <Stack display="grid" className="templateGridForm">
            <FieldSelect
              label="Direita"
              value={data.sinalDeHoffmannDireita}
              setValue={(value) =>
                handleSetData(value, "sinalDeHoffmannDireita")
              }
              items={reflexoOptions.map((c) => {
                return { id: c.value, label: c.key };
              })}
            />
            <FieldSelect
              label="Esquerda"
              value={data.sinalDeHoffmannEsquerda}
              setValue={(value) =>
                handleSetData(value, "sinalDeHoffmannEsquerda")
              }
              items={reflexoOptions.map((c) => {
                return { id: c.value, label: c.key };
              })}
            />
          </Stack>
        </Stack>
      </Stack>

      <Stack className="templateGridForm">
        <FieldSelect
          label="Tremor"
          value={data.tremor}
          setValue={(value) => handleSetData(value, "tremor")}
          items={simOuNaoOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Bradicinesia"
          value={data.ataxia}
          setValue={(value) => handleSetData(value, "ataxia")}
          items={simOuNaoOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <FieldSelect
          label="Ataxia"
          value={data.bradicinesia}
          setValue={(value) => handleSetData(value, "bradicinesia")}
          items={simOuNaoOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
        />
        <Stack></Stack>
      </Stack>

      <Stack
        direction="row"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 3,
        }}
      >
        <Button className="buttonText cancel" variant="outlined">
          Cancelar
        </Button>
        <Button
          className="buttonText submit"
          variant="outlined"
          type="submit"
          name="motor"
        >
          Salvar
        </Button>
      </Stack>
    </form>
  );
}
